export const licenseData = [
    { state: 'Florida', licenseNumber: 'W901294', name: 'Esteban Andres Pimentel' },
    { state: 'Georgia', licenseNumber: '3644856', name: 'Esteban Andres Pimentel' },
    { state: 'North Carolina', licenseNumber: '20496983', name: 'Moonish Maredia' },
    { state: 'Texas', licenseNumber: '2913438', name: 'Moonish Maredia' },
    { state: 'Missouri', licenseNumber: '3002720442', name: 'Esteban Andres Pimentel' },
    { state: 'Utah', licenseNumber: '1000174', name: 'Esteban Andres Pimentel' },
    // Add more rows as needed
  ];